import i18n from '../../i18n';

export function truncateString(str: string, num: number) {
  if (str.length > num) {
    return str.slice(0, num) + '...';
  } else {
    return str;
  }
}

export default {
  lockTheTask: 'قفل کردن وظیفه',
  lockTaskInfo:
    'پس قفل یا باز کردن یکی از ویژگی‌ها بایستی وظیفه را ذخیره کنید.',
  lockMark: 'قفل کردن تغییر وضیعت انجام کاربران',
  lockProps: 'قفل کردن ویرایش فیلد‌های وظیفه',
  preferences: 'تنظیمات پیشرفته',
  taskChanged:
    'وضعیت وظیفه‌ی شما تغییر کرده است. لطفاً تغییرات را ذخیره نمایید.',
  setParentTab: 'تنظیم مکان',
  setReminderTab: 'یادآور',
  withoutParent: 'بدون مکان',
  aTaskCannotBeChildOfItself: 'یک وظیفه نمی‌تواند گامی برای خودش باشد',
  currentStatus: 'مکان فعلی: ',
  draftTask: 'تغییر به پیشنویس',
  moveToProject: 'انتقال به پروژه',
  project: 'پروژه',
  searchTask: 'جستجوی وظیفه',
  taskUpdated: 'وظیفه با موفقیت به‌روزرسانی شد.',
  archiveTaskHint:
    'هنگامی که کار همه‌ی افراد مرتبط با این وظیفه به پایان رسید، می‌توانید آن را بایگانی کنید.',
  save: 'ذخیره',
  searchATaskToSelectItAsTheParentOfThisTask:
    'در صورتی که می‌خواهید این وظیفه به عنوان زیر وظیفه یک وظیفه دیگر باشد آن را جستجو کنید',
  selectAProjectToMoveTaskTo:
    'برای تعیین پروژه این  وظیفه، پروژه را انتخاب کنید',
  deleteArchiveTask: 'بایگانی/حذف وظیفه',
  deleteTask: 'حذف وظیفه',
  restoreTask: 'بازگردانی وظیفه',
  archiveTask: 'بایگانی وظیفه',
  unArchiveTask: 'بازیابی وظیفه',
  countToDeleteTask: 'جلوگیری از حذف',
  statusTitle(title: string) {
    return `«${title}»`;
  },
  confirmDeleteATask(taskTitle: string, subTasksTitle?: string) {
    const subTasksCustomTitle = subTasksTitle
      ? subTasksTitle
      : i18n.t('steps', { ns: 'taskManager' });

    return i18n.t('confirmDeleteATask', {
      ns: 'taskManager',
      taskTitle: truncateString(taskTitle, 50),
      subtaskTitle: subTasksCustomTitle,
    });
  },
  confirmRestoreTask(taskTitle: string, subTasksTitle?: string) {
    const subTasksCustomTitle = subTasksTitle
      ? subTasksTitle
      : i18n.t('steps', { ns: 'taskManager' });
    return i18n.t('confirmRestoreTask', {
      ns: 'taskManager',
      taskTitle: truncateString(taskTitle, 50),
      subtaskTitle: subTasksCustomTitle,
    });
  },
  hintToDeleteTask(
    taskName: string,
    title: string,
    subTaskTitle: string,
    deleteState: 'Deleted' | 'ParentDeleted' | 'deleted' | null
  ) {
    if (!deleteState)
      return i18n.t('hintToDeleteTask1', {
        ns: 'taskManager',
        taskTitle: truncateString(title, 50),
        subtaskTitle: subTaskTitle,
      });
    else if (deleteState === 'ParentDeleted') {
      return i18n.t('hintToDeleteTask2', { ns: 'taskManager', taskName });
    }
    return i18n.t('hintToDeleteTask3', {
      ns: 'taskManager',
      taskName,
      subtaskTitle: subTaskTitle,
    });
  },
  hintToDraftTask(taskName: string, title: string, subTaskTitle: string) {
    return i18n.t('hintToDraftTask', {
      ns: 'taskManager',
      taskName,
      taskTitle: truncateString(title, 50),
      subtaskTitle: subTaskTitle,
    });
  },
  taskIsDraft(taskName: string) {
    return i18n.t('taskIsDraft', { ns: 'taskManager', taskName });
  },
};
